/// <summary>Create Swal Alert</summary>
/// <param name="icon">error, success, warning, info, question</param>
/// <param name="text">message</param>
/// <param name="title">message title</param>
/// <param name="buttontext">Confirm button on text</param>
/// <param name="buttontext">normal, confirm</param>
/// <remarks>more information https://sweetalert2.github.io/ </remarks>
function SwalGenerate(icon, text, title, buttontext) {
    var ButtonColor = '#a5dc86';
    var ImageIcon = "https://www.originalseconds.com/ContentImages/warning-black.png";
    if (icon == "error") {
        ButtonColor = "#f27474";
    }
    else if (icon == "warning") {
        ButtonColor = "#f8bb86";
    }

    var message = "";

    if ($.isArray(text)) {
        if (text != undefined && text.length > 0) {
            for (var i = 0; i < text.length; i++) {
                message += text[i] + "<br />";
            }
        }
    }
    else {
        message = text;
    }
    if (icon == "success") {
        ImageIcon = "/ContentImages/success-black.png";
    }
    Swal.fire({
        title: title,
        html: message,
        //icon: icon,
        imageUrl: ImageIcon,
        imageSize: '64x64',
        showCloseButton: true,
        confirmButtonText: buttontext,
        confirmButtonColor: ButtonColor
    });
}

/// <summary>Generate Loading Overlay</summary>
/// <param name="ParentElement">loading container element</param>
/// <param name="operation">show or hide</param>
function GenerateLocalLoading(ParentElement, operation) {
    var AddingOverlayHtml = '<div class="loading-overlay"><i class="button-loader"></i></div>';

    if (operation == "show") {
        if (ParentElement.find("loading-overlay").length == 0) {
            ParentElement.append(AddingOverlayHtml);
        }
    }
    else if (operation == "hide") {
        ParentElement.find(".loading-overlay").remove();
    }
}

// #region Device, Browser, Query, IsNumeric Determination(Old common.js)
function isMobileResolution() {
    if ($(window).width() <= 991) {
        return true;
    }
    else {
        return false;
    }
}

function isMobile(forceResolution) {

    var isMobile = false;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) || (forceResolution == true && $(window).width() < 1000)) {
        isMobile = true;
    }

    return isMobile;
}

function isAppleMobile() {

    var isAppleMob = false;

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        isAppleMob = true;
    }

    return isAppleMob;
}

function isIpad() {

    var is_ipad = navigator.userAgent.toLowerCase().indexOf('ipad') > -1;

    return is_ipad;
}

function IsChrome() {

    var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

    return isChrome;
}

function IsSafari() {

    var safari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
    var android = navigator.userAgent.toLowerCase().indexOf('android') > -1;

    if (safari && android) {
        safari = false;
    }

    return safari;
}

function IsAndroidSafari() {

    var safari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
    var android = navigator.userAgent.toLowerCase().indexOf('android') > -1;

    if (safari && android) {
        return true;
    }

    return false;
}

function IsAndroid() {

    var android = navigator.userAgent.toLowerCase().indexOf('android') > -1;

    if (android) {
        return true;
    }

    return false;
}

function IsFirefox() {

    var isFF = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    return isFF;
}

function compress(data) {
    var q = {}, ret = "";
    data.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
        q[key] = (q[key] ? q[key] + "," : "") + value;
    });
    for (var key in q)
        ret = (ret ? ret + "&" : "") + key + "=" + q[key];
    return ret;
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function getQuery(url) {

    var q = (url.split('?')[1] || '').split('&'), o = {};
    for (var i = 0; i < q.length; i++) {
        var p = q[i].split('=');
        if (!!p[0]) o[unescape(p[0])] = unescape(p[1] || '');
    }
    return o;
}

function fnIsAppleMobile() {
    if (navigator && navigator.userAgent && navigator.userAgent != null) {
        var strUserAgent = navigator.userAgent.toLowerCase();
        var arrMatches = strUserAgent.match(/(iphone|ipod|ipad)/);
        if (arrMatches)
            return true;
    } // End if (navigator && navigator.userAgent) 

    return false;
}

function hexToRgb(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function RenkKontrol(color) {
    var Return = (color[0] & 255) + (color[1] & 255) + (color[2] & 255) < 3 * 256 / 2;
    return Return;
}
// #endregion

/// <summary>This event is fired when the modal has finished being hidden from the user</summary>
/// <param name="Modal">Selected ModalID</param>
function ModalHideEvent(Modal, ClearElement) {
    Modal.on('hidden.bs.modal', function (e) {
        $(this).find(ClearElement).html("");
    });
}

/// <summary>Make iframe automatically adjust height according to the contents without using scrollbar</summary>
/// <param name="obj">change your iframe to this</param>
function resizeIframe(obj) {
    var objHeight = obj.contentWindow.document.documentElement.scrollHeight + 50;
    obj.style.height = objHeight + 'px';
}

/// <summary>Register a handler to be called when Ajax requests complete.</summary>
function ReloadOnTimeOut() {
    $(document).ajaxComplete(function (event, xhr, setting) {
        if (xhr != null && xhr != undefined) {
            $responseAjax = xhr.responseJSON;

            if ($responseAjax != null && $responseAjax != undefined && $responseAjax.StatusText == "CheckOutStateTimeOut") {
                document.location.reload(true);
            }
        }
    });
}

/// <summary>Detect and validate credit card numbers.</summary>
function validateCardNumber(number) {
    var regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(number))
        return false;

    return luhnCheck(number);

    function luhnCheck(val) {
        var sum = 0;
        for (var i = 0; i < val.length; i++) {
            var intVal = parseInt(val.substr(i, 1));
            if (i % 2 == 0) {
                intVal *= 2;
                if (intVal > 9) {
                    intVal = 1 + (intVal % 10);
                }
            }
            sum += intVal;
        }
        return (sum % 10) == 0;
    }
}

/// <summary>Format credit card number.</summary>
function formatCCnumber(value) {
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || '';
    var parts = [];

    for (i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
        return parts.join(' ');
    }
    else {
        return value;
    }
}

/// <summary>Finds whether a variable is a number or a numeric string.</summary>
function IsNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function getResourceValue(resourceName, callback) {
    // ajax isteği
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetResourceValue",
        data: "ResourceKey=" + resourceName,
        cache: false,
        async: true,
        success: function (data) {
            callback(data);
        }
    });
}

function getStandartMessages(messageKey) {
    var words = "";
    var langCode = $("#SmallLangCode").val();

    if (langCode == "tr") {
        words = {
            BirHataOlustu: "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
            IslemBasarisiz: "İşlemin Başarısız",
            IslemBasarili: "İşlemin Başarılı",
            Kapat: "Kapat",
            Geri: "Geri",
            LutfenKuponSecin: "Lutfen kupon seçin",
            Hata: "Hata",
            TekrarDene: "Tekrar Dene",
            DevamEtmekIcınOdemeYontemi: "Devam etmek için ödeme yöntemi seçin",
            GecerliTelefonNumarasi: "Lütfen geçerli bir telefon numarası giriniz",
            LutfenTumAlanlariDoldurun: "Lütfen tüm alanları doldurun",
            AdresSilindi: "Adres silindi",
            MesajinizIletildi: "Mesajınız başarılı bir şekilde iletildi. En kısa sürede mesajınıza yanıt verilecektir.",
            SifremiYenile: "Şifremi Yenile",
            YenidenHosgeldiniz: "Seni Görmek Ne güzel!",
            GirisYap: "Giriş Yap",
            LutfenUlkeSeçin: "Lütfen devam etmek istediğiniz ülkeyi seçin",
            LutfenBirDilSecin: "Lütfen bir dil seçin",
            LutfenBekleyin: "Lütfen Bekleyin...",
            FavorilerIcinGirisYapin: "Favorilere eklemek için giriş yapmalısın.",
            Renk: "Renk",
            Beden: "Beden",
            Fiyat: "Fiyat",
            Ozellik: "Özellik",
            Kumas: "Kumaş",
            Kategori: "Kategori",
            Departman: "Departman",
            Sezon: "Sezon",
            SecimleriTemizle: "Seçimleri Temizle",
            Marka: "Marka",
            GirisHata: "Hesabına Giriş Yapılamadı"
        };
    }
    else { // Hiçbirine uymuyorsa İngilizce getirsin
        words = {
            BirHataOlustu: "An error has occurred.",
            IslemBasarisiz: "Process Failed",
            IslemBasarili: "Process Successful",
            Kapat: "Close",
            Geri: "Back",
            LutfenKuponSecin: "Please coupon select",
            Hata: "Failed",
            TekrarDene: "Try Again",
            DevamEtmekIcınOdemeYontemi: "Please payment type to continue",
            GecerliTelefonNumarasi: "Please valid GSM Number",
            LutfenTumAlanlariDoldurun: "Please fill all informations",
            AdresSilindi: "Address deleted",
            MesajinizIletildi: "Your message has been sent.",
            SifremiYenile: "Renew My Password",
            YenidenHosgeldiniz: "Welcome Again",
            GirisYap: "Login",
            LutfenUlkeSeçin: "Please select the country you want to continue",
            LutfenBirDilSecin: "Please select a language",
            LutfenBekleyin: "Please Wait...",
            FavorilerIcinGirisYapin: "You must be logged in to add to favorites.",
            Renk: "Color",
            Beden: "Size",
            Fiyat: "Price",
            Ozellik: "Propertie",
            Kumas: "Cloth",
            Kategori: "Category",
            Departman: "Department",
            Sezon: "Season",
            SecimleriTemizle: "Clear Selections",
            Marka: "Brand",
            GirisHata: "Hesabına Giriş Yapılamadı"
        };
    }

    return words[messageKey];
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function getRequestRoute() {
    var route = "/" + $("#SmallCountryCode").val() + "/" + $("#SmallLangCode");
    route = "";

    return route;
}

function generateToolTip() {
    if (!isMobileResolution()) {
        $('[data-toggle="tooltip"]').tooltip();
    }
}

function getAddBasketMessage(key) {
    var words = "";
    if (key > 7) {
        key = 7;
    }
    words = {
        1: "Çok cool bir seçim :)",
        2: "Bugün modundasın...",
        3: "Tarzını sevdim.",
        4: "Devam et, pişman olmayacaksın...",
        5: "Kim tutar seni!",
        6: "Gardırobunda yer aç.",
        7: " Artık sen de bizdensin :)"
    };
    return words[key];
}